import axios from "axios";

export default function validateRange({ fromSn, toSn, inputType }) {
  return new Promise((resolve, reject) =>
    axios
      .post("/serialnumber/system-admin/api/v1/management-sn/validate-range", {
        from_sn: fromSn,
        to_sn: toSn,
        input_type: inputType,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data?.message || error.message))
  );
}
